import React from 'react';
import CTABanner from '../components/landingPage/CTABanner';
import SocialMediaCTA from '../components/SocialMediaCTA';
import NewsSection from '../components/landingPage/NewsSection';

const OrganizationStructurePage = () => {
  return (
    <div className="min-h-screen pt-40 bg-white font-poppins py-12"> {/* Changed bg-gray-100 to bg-white */}
      <div className="container mx-auto px-4 max-w-7xl"> {/* Added max-w-7xl */}
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#364A9A] text-center mb-8 sm:mb-12">
          ORGANIZATION STRUCTURE
        </h1>
        {/* <div className="w-24 h-1 bg-[#ECEE07] mx-auto mb-12"></div> Separator */}

        <section className="mb-12 sm:mb-16">
          <div className="bg-white rounded-lg shadow-lg p-8">
            <h2 className="text-xl font-bold text-[#364A9A] mb-4 text-center">Organizational Chart</h2>
            <img src="/org_structure/org_structure.jpg" alt="Organizational Structure" className="w-full h-auto max-h-[90vh] object-contain mt-4 mx-auto block" />
          </div>
        </section>

        <CTABanner className="my-8 sm:my-12" />
        <SocialMediaCTA className="my-8 sm:my-12" />
        <NewsSection className="my-8 sm:my-12" />
      </div>
    </div>
  );
};

export default OrganizationStructurePage;
